export default "__VITE_ASSET__CuMEz7bT__"